import { render, staticRenderFns } from "./LanguageIcon.vue?vue&type=template&id=6746729e&scoped=true&"
import script from "./LanguageIcon.vue?vue&type=script&lang=js&"
export * from "./LanguageIcon.vue?vue&type=script&lang=js&"
import style0 from "./LanguageIcon.vue?vue&type=style&index=0&id=6746729e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6746729e",
  null
  
)

export default component.exports